export var OrientationMode;
(function (OrientationMode) {
    /**
     *
     */
    OrientationMode[OrientationMode["DEFAULT"] = 0] = "DEFAULT";
    /**
     *
     */
    OrientationMode[OrientationMode["CAMERA_PLANE"] = 1] = "CAMERA_PLANE";
    /**
     *
     */
    OrientationMode[OrientationMode["CAMERA_POSITION"] = 2] = "CAMERA_POSITION";
})(OrientationMode || (OrientationMode = {}));
